// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2r5RJ","footer":"ModalError_footer__19uwo"};